import React from 'react';
import TituloDaPagina from '../../components/TituloDaPagina'

export default function Lojas() {
  return (
    <>
      <TituloDaPagina>Lojas</TituloDaPagina>
    </>
  );
}
